import React, { useEffect, useState, useRef } from 'react'
import { Bar, Pie } from 'react-chartjs-2'
import Navbar from '../../components/navbar/navbar.jsx'
import apinode from '../../services/apinode.js'
import ItemList from './ItemList.jsx'
import DashboardVendas from './cards.jsx'
import AnunciosDashboard from './semsku.jsx'
import { FaTrophy } from "react-icons/fa";
import GreetingCard from './greetingCard.jsx'
import ScheduleCard from './schedule_card.jsx'
import DashboardMonthly from './dashReclaim.jsx'
import CatalogNotification from './catalago.jsx'
import {
  Filter,
  Hash,
  Trophy,
  AlertTriangle,
  Crown,
  Medal,
  Star,
  TrendingUp,
  TrendingDown,
  DollarSign,
  Store,
  Sparkles,
  Award,
  Target,
  ShoppingCart,
  ShoppingBag,
  Package,
  BarChart3,
  Calendar,
  AlertCircle,
  Zap,
  ArrowRight,
  Truck,
  Loader2,
  MapPin,
  ChevronUp,
  ChevronDown,
  Edit,
  PenTool,
  CreditCard,
  Plus,
  QrCode,
  RefreshCw,
  Copy,
  CheckCircle,
  Scissors,
  Undo,
  Trash2,
  Share,
  User,
  FileText,
  Bike
} from "lucide-react";




import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ArcElement, Chart as ChartJS, Legend, Tooltip } from 'chart.js'
import { getMessaging, getToken } from 'firebase/messaging'
import {
  Tooltip as BootstrapTooltip,
  Button,
  Card,
  Col,
  Container,
  Modal,
  OverlayTrigger,
  Row,
  Table,
  Toast,
} from 'react-bootstrap'

import Lottie from 'lottie-react'
import Dropdown from 'react-bootstrap/Dropdown'
import DatePicker from 'react-datepicker'
import 'react-datepicker/dist/react-datepicker.css'
import { FaArrowDown, FaArrowUp } from 'react-icons/fa'
import animacaoLottie from './animacao.json'

import { format, isBefore, startOfDay } from 'date-fns'
import { utcToZonedTime } from 'date-fns-tz'

import {
  faBox,
  faDollarSign,
  faGear,
  faMoneyBills,
  faMoneyBillTrendUp,
  faMoneyBillWave,
  faShoppingCart,
  faTimesCircle,
  faTruckFast,
} from '@fortawesome/free-solid-svg-icons'
import { Line } from 'react-chartjs-2'
import './dashboard.css'

import { faBolt } from '@fortawesome/free-solid-svg-icons'
import ptBR from 'date-fns/locale/pt-BR' // Importe a localização em português
import { DateTime } from 'luxon' // Importe a classe DateTime do Luxon
import { Info, WarningCircle } from 'phosphor-react'
import { AwardFill, BoxArrowUpRight } from 'react-bootstrap-icons'
import { useNavigate } from 'react-router-dom'
import { toast } from 'react-toastify'
import 'slick-carousel/slick/slick-theme.css'
import 'slick-carousel/slick/slick.css'
import { Center } from '../../components/Center/index.jsx'
import { CustomButton } from '../../components/CustomButton/index.jsx'
import { CustomSpinner } from '../../components/CustomSpinner/index.jsx'
import PedidosService from '../../services/database/PedidosService/index.js'
import { formatDate } from '../../utils/formatDate.js'
import { formatPrice } from '../../utils/formatPrice.js'
import { sendErrorApiMessage } from '../../utils/sendErrorApiMessage.js'
import {
  AccountDate,
  AccountTitle,
  AccountTotal,
  Code,
  CodeContent,
  Codes,
  DateSection,
} from './styles.js'

ChartJS.register(ArcElement, Tooltip, Legend)

function Main() {
  const [selectedDate, setSelectedDate] = useState(new Date())
  const [dadosDashboard, setDadosDashboard] = useState(null)
  const [dadosVendas, setDadosVendas] = useState([])
  const [dadosVendasFull, setDadosVendasFull] = useState([])
  const [dadosVendasComparativo, setDadosVendasComparativo] = useState({
    ontem: {},
    hoje: {},
  })
  const [statistics, setStatistics] = useState([])
  const [dadosMetricas, setMetricas] = useState([])
  const [isLoading, setIsLoading] = useState(false) // Adicione um estado para controlar o carregamento
  const [isLoadingAno, setIsLoadingAno] = useState(false) // Adicione um estado para controlar o carregamento
  const [dados, setDados] = useState([])
  const [showToast, setShowToast] = useState(false)
  const [totalPerguntas, setTotalPerguntas] = useState(0)
  const [totalDiario, setTotalDiario] = useState([])
  const [anuncios, setAnuncios] = useState([])
  const [greeting, setGreeting] = useState('')

  const [dailySales, setDailySales] = useState([])
  const [isDailySalesLoading, setISDailySalesLoading] = useState(false)
  const [isModalDailySalesOpen, setIsModalDailySalesOpen] = useState(false)
  const [showModal, setShowModal] = useState(false)
  const handleShow = () => setShowModal(true)
  const handleClose = () => setShowModal(false)

  const [contas, setContas] = useState([])
  const [isCodesLoading, setIsCodesLoading] = useState(true)


  // Função de formatação (você já deve ter ela)
  const formatarValorReal = (valor) => {
    return valor.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    });
  };

  const total = contas?.reduce((acc, conta) => {
    if (conta?.total) {
      acc = acc + conta.total
    }

    return acc
  }, 0)

  async function loadContas() {
    try {
      setIsCodesLoading(true)

      const response = await apinode.get(
        `/mercado-livre/auth-codes/${localStorage.idconta}`,
      )

      setContas(response.data)
    } catch (err) {
      sendErrorApiMessage('Erro', 'Não foi possível buscar os códigos', err)
    } finally {
      setIsCodesLoading(false)
    }
  }

  useEffect(() => {
    loadContas()
  }, [])

  // Função para definir saudação de acordo com a hora
  const determineGreeting = () => {
    const currentHour = new Date().getHours()

    if (currentHour >= 0 && currentHour < 12) {
      return 'Bom dia'
    } else if (currentHour >= 12 && currentHour < 18) {
      return 'Boa tarde'
    } else {
      return 'Boa noite'
    }
  }

  async function getDailySales() {
    try {
      setISDailySalesLoading(true)

      const data = await PedidosService.getDailySales(new Date())

      setDailySales(data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar as vendas do dia!')
    } finally {
      setISDailySalesLoading(false)
    }
  }

  useEffect(() => {
    const greetingMessage = determineGreeting()
    setGreeting(greetingMessage)
  }, [])

  const [anoSelecionado, setAnoSelecionado] = useState(new Date().getFullYear())
  // const [anoSelecionado, setAnoSelecionado] = useState(anoInicial); // onde `anoInicial` é o ano inicial selecionado

  const anosDisponiveis = [2025, 2024, 2023, 2022, 2021, 2020] // Você pode adicionar os anos que desejar

  const navigate = useNavigate()

  async function getStatistics() {
    try {
      const response = await apinode.get(
        `/accounts-statistics/${localStorage.idconta}`,
      )

      setStatistics(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar as contas!')
    }
  }

  async function getAnuncios() {
    try {
      const response = await apinode.get(
        `/anuncios/count/${localStorage.idconta}`,
      )

      setAnuncios(response.data)
    } catch (err) {
      sendErrorApiMessage(err, 'Não foi possível buscar os anúncios!')
    }
  }

  useEffect(() => {
    getAnuncios()
    getStatistics()
  }, [])

  const handleChangeAno = (ano) => {
    setAnoSelecionado(ano)
    VendasporAno()
    console.log(anoSelecionado)
    // Aqui você pode adicionar a lógica para atualizar os dados com base no ano selecionado
  }

  const handleDropdownChange = (ano) => {
    setAnoSelecionado(ano)
    VendasporAno(ano)
    console.log(ano)
  }

  // const fetchPerguntas = async () => {
  //   try {
  //     const response = await apinode.get(
  //       `/mercadolibreperguntas/${localStorage.idconta}`,
  //     )
  //     const total = response.data.totais
  //     setTotalPerguntas(total)

  //     if (total > 0) {
  //       toast.info('Há novas perguntas para responder, clique aqui!', {
  //         onClick: () => {
  //           navigate('/perguntas')
  //         },
  //       })
  //     }
  //   } catch (error) {
  //     console.error('Erro ao buscar os dados:', error)
  //   }
  // }

  const handleDateChange = (date) => {
    // fetchDashboardData(date); // Buscar dados com base na nova data
    console.log(date, 'change')
    setIsLoading(true) // Inicie o indicador de carregamento ao alterar a data
    fetchData(date)
    CosumirPorloja(date) // Chama a função aqui
    ConsumirFull(date)
    setSelectedDate(date)
    console.log('pesquisando por data', date)
  }

  function DateSelector({ onDateChange }) {
    const [selectedDate, setSelectedDate] = useState(new Date())

    // Função chamada quando a data é alterada
    const handleDateChange = (date) => {
      setSelectedDate(date)
      onDateChange(date) // Chama a função de retorno com a data selecionada
    }
  }

  const GraficoComparativo = () => {
    const meses = dados.map((item) => item.MES)
    const vendasBruto = dados.map((item) => item.TOTAL_VENDAS_BRUTO)
    const frete = dados.map((item) => item.FRETE)
    const vendaLiquida = dados.map((item) => item.VENDA_LIQUIDA)

    const data = {
      labels: meses,
      datasets: [
        {
          label: 'Vendas Bruto',
          backgroundColor: 'rgba(75, 192, 192, 0.6)',
          data: vendasBruto,
        },
        {
          label: 'Frete',
          backgroundColor: 'rgba(255, 99, 132, 0.6)',
          data: frete,
        },
        {
          label: 'Venda Líquida',
          backgroundColor: 'rgba(0, 128, 0, 0.6)', // Cor verde
          data: vendaLiquida,
        },
      ],
    }

    const options = {
      scales: {
        y: {
          beginAtZero: true,
        },
      },
    }

    return (
      <div>
        <Card className="mb-3">
          <Card.Body>
            <h2>Gráfico Comparativo Melhorado</h2>
            <Bar
              data={data}
              options={options}
            />
          </Card.Body>
        </Card>
      </div>
    )
  }

  function formatarNumero(numero) {
    return numero.toLocaleString('pt-BR', {
      style: 'currency',
      currency: 'BRL',
    })
  }

  function TabelaComparativa() {
    const formatarNumero = (valor) => {
      // Verifica se o valor é null e, se for, define-o como 0
      if (valor === null) {
        valor = 0
      }
      // Formata o número com uma casa decimal e adiciona sinal "+" ou "-"
      return valor.toLocaleString('pt-BR', {
        style: 'decimal',
        minimumFractionDigits: 2,
      })
    }

    return (
      <div className="container">
        <Modal
          show={showModal}
          onHide={handleClose}
          centered
          dialogClassName="custom-modalzpl"
        >
          <Modal.Header closeButton>
            <Modal.Title>Itens Vendidos</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {dadosDashboard &&
              dadosDashboard.totalItensParts &&
              dadosDashboard.totalItensParts.length > 0 ? (
              <Table
                striped
                bordered
                hover
                responsive
                className="text-center align-middle"
              >
                <thead className="table">
                  <tr>
                    <th>Loja Virtual</th>
                    <th>SKU</th>
                    <th>Descrição</th>
                    <th>Quantidade</th>

                    <th>Valor Total</th>
                  </tr>
                </thead>
                <tbody>
                  {dadosDashboard.totalItensParts.map((item, index) => (
                    <tr key={index}>
                      <td>{item.apelido_loja}</td>
                      <td>{item.sku}</td>
                      <td>{item.descricao || 'Sem descrição'}</td>
                      <td>{item.quantidade_total}</td>

                      <td>
                        {item.valor_total_vendido?.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            ) : (
              <p className="text-center">Nenhum item vendido.</p>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button
              variant="dark"
              className="w-100"
              onClick={handleClose}
            >
              Fechar
            </Button>
          </Modal.Footer>
        </Modal>
        <div className="table-responsive">
          <table className="table table-striped">
            <thead>
              <tr>
                <th>Mês</th>
                <th>Bruto</th>
                <th>Líquido</th>
                <th>Diferença</th>
                <th>%</th>
              </tr>
            </thead>
            <tbody>
              {dados.map((mes, index) => {
                const mesAnterior = index > 0 ? dados[index - 1] : null
                const diferenca = mesAnterior
                  ? mes.VENDA_LIQUIDA - mesAnterior.VENDA_LIQUIDA
                  : 0
                const percentualDiferenca = mesAnterior
                  ? ((diferenca / mesAnterior.VENDA_LIQUIDA) * 100).toFixed(2)
                  : 0

                return (
                  <tr key={index}>
                    <td>{mes.MES.trim()}</td>
                    <td>{formatarNumero(mes.TOTAL_VENDAS_BRUTO)}</td>
                    <td>
                      <span
                        className={`font-12 ${index === 0
                          ? ''
                          : diferenca > 0
                            ? 'text-success'
                            : 'text-danger'
                          }`}
                      >
                        {formatarNumero(mes.VENDA_LIQUIDA)}
                      </span>
                    </td>
                    <td>
                      <span
                        className={
                          index === 0
                            ? ''
                            : diferenca > 0
                              ? 'text-success'
                              : 'text-danger'
                        }
                      >
                        {index === 0
                          ? ''
                          : diferenca > 0
                            ? `+${formatarNumero(diferenca)}`
                            : `${formatarNumero(diferenca)}`}
                      </span>
                    </td>
                    <td>
                      <span
                        className={
                          index === 0
                            ? ''
                            : diferenca > 0
                              ? 'text-success'
                              : 'text-danger'
                        }
                      >
                        {index === 0
                          ? ''
                          : `${index === 0 ? '' : `${percentualDiferenca}%`}`}
                      </span>
                    </td>
                  </tr>
                )
              })}
            </tbody>
          </table>
        </div>
      </div>
    )
  }

  // Mapeamento dos nomes dos dias em inglês para português
  const daysOfWeek = {
    sunday: 'Domingo',
    monday: 'Segunda-feira',
    tuesday: 'Terça-feira',
    wednesday: 'Quarta-feira',
    thursday: 'Quinta-feira',
    friday: 'Sexta-feira',
    saturday: 'Sábado',
  }

  const CodigosAutorizacao = () => {
    return (
      <Card>
        <Card.Body>
          <h5 className="card-title">Códigos de Autorização</h5>

          {isCodesLoading ? (
            <Center column>
              <CustomSpinner />
              <p>Carregando...</p>
            </Center>
          ) : (
            <Codes className="mt-3">
              {contas.length === 0 ? (
                <AccountTitle>Sem dados disponíveis</AccountTitle>
              ) : (
                <>
                  {total !== 0 && (
                    <Code>
                      <CodeContent>
                        <AccountTitle>Geral</AccountTitle>

                        <AccountTotal>Total: {total}</AccountTotal>
                      </CodeContent>
                    </Code>
                  )}

                  {contas.map((conta) => {
                    const isOutOfDate =
                      conta?.data_adicao &&
                      isBefore(
                        startOfDay(conta?.data_adicao),
                        startOfDay(new Date()),
                      )

                    return (
                      <Code key={conta.id}>
                        <CodeContent>
                          <AccountTitle>
                            {conta.apelido} {conta.nome && `- ${conta.nome}`}
                          </AccountTitle>

                          <AccountTotal>
                            {conta?.total
                              ? `Total: ${conta.total}`
                              : `Total não disponível`}
                          </AccountTotal>
                        </CodeContent>

                        {conta?.data_adicao && (
                          <DateSection>
                            {isOutOfDate ? (
                              <WarningCircle
                                size={16}
                                color="#ff5733"
                              />
                            ) : (
                              <Info size={16} />
                            )}

                            <AccountDate color={isOutOfDate && '#ff5733'}>
                              {isOutOfDate
                                ? 'Código antigo, necessário atualizar'
                                : `Código adicionado em ${formatDate(conta.data_adicao)}`}
                            </AccountDate>
                          </DateSection>
                        )}

                        <AccountTitle>
                          {conta?.codigo
                            ? conta?.codigo
                            : 'Código não disponível'}
                        </AccountTitle>
                      </Code>
                    )
                  })}
                </>
              )}
            </Codes>
          )}
        </Card.Body>
      </Card>
    )
  }

  // console.log(sellerData)

  // const ScheduleCard = ({ sellerData }) => {
  //   const [collapsed, setCollapsed] = useState(true)

  //   const toggleCollapse = () => {
  //     setCollapsed(!collapsed)
  //   }

  //   if (!sellerData || sellerData.length === 0) {
  //     // Caso sellerData seja nulo ou vazio, retorne uma mensagem ou qualquer conteúdo desejado
  //     return (
  //       <div className="card">
  //         <div className="card-body">
  //           <h5 className="card-title">Horários de coleta</h5>
  //           <p>Nenhum dado disponível no momento.</p>
  //         </div>
  //       </div>
  //     )
  //   }

  //   return (
  //     <div className="card">
  //       <div className="card-body">
  //         <h5 className="card-title">
  //           Horários de coleta
  //           <button
  //             className={`btn btn-link float-end ${collapsed ? 'collapsed' : ''
  //               }`}
  //             type="button"
  //             data-bs-toggle="collapse"
  //             data-bs-target="#scheduleTable"
  //             aria-expanded={!collapsed}
  //             onClick={toggleCollapse}
  //           >
  //             {collapsed ? 'Expandir' : 'Recolher'}
  //           </button>
  //         </h5>

  //         <div
  //           className={`collapse ${collapsed ? '' : 'show'}`}
  //           id="scheduleTable"
  //         >
  //           {sellerData.map((seller) => {
  //             const sellerId = Object.keys(seller)[0]
  //             const schedule = seller[sellerId].schedule

  //             return (
  //               <div key={sellerId}>
  //                 <div className="table-responsive">
  //                   <span className="badge bg-primary text-white">
  //                     Vendedor ID: {sellerId}
  //                   </span>

  //                   <table className="table table-bordered">
  //                     <thead>
  //                       <tr>
  //                         <th>Dia</th>
  //                         <th>Trabalho</th>
  //                         <th>Horário de Início</th>
  //                         <th>Horário de Término</th>
  //                         <th>Corte</th>
  //                         <th>Transportadora</th>
  //                         <th>Veículo</th>
  //                         <th>Motorista</th>
  //                         <th>Tipo Logístico</th>
  //                       </tr>
  //                     </thead>
  //                     <tbody>
  //                       {Object.keys(schedule).map((day) => {
  //                         const detail = schedule[day].detail
  //                         return (
  //                           <tr key={day}>
  //                             <td>{daysOfWeek[day]}</td>
  //                             <td>{schedule[day].work ? 'Sim' : 'Não'}</td>
  //                             {detail ? (
  //                               <>
  //                                 <td>{detail[0].from}</td>
  //                                 <td>{detail[0].to}</td>
  //                                 <td>{detail[0].cutoff}</td>
  //                                 <td>{detail[0].carrier.name}</td>
  //                                 <td>{`${detail[0].vehicle.vehicle_type} - ${detail[0].vehicle.license_plate}`}</td>
  //                                 <td>{detail[0].driver.name}</td>
  //                                 <td>{detail[0].logistic_type}</td>
  //                               </>
  //                             ) : (
  //                               <td colSpan="8">Não disponível</td>
  //                             )}
  //                           </tr>
  //                         )
  //                       })}
  //                     </tbody>
  //                   </table>
  //                 </div>
  //               </div>
  //             )
  //           })}
  //         </div>
  //       </div>
  //     </div>
  //   )
  // }




  const ComparativoValorTotalCard = ({ informacoesVendas }) => {
    if (
      !informacoesVendas ||
      !informacoesVendas.ontem ||
      !informacoesVendas.hoje
    ) {
      return null // Retorna null se os dados não forem válidos
    }

    const ontem = informacoesVendas.ontem
    const hoje = informacoesVendas.hoje

    // Verifica se os valores de ontem e hoje são números válidos
    if (isNaN(ontem.valorTotal) || isNaN(hoje.valorTotal)) {
      return null // Retorna null se os valores não forem números válidos
    }

    // Determina o ícone e a classe de cor com base no valor (seta para cima se hoje for maior, seta para baixo se hoje for menor)
    let iconeOntem = null
    let iconeHoje = null
    let corClasseOntem
    let corClasseHoje

    if (hoje.valorTotal > ontem.valorTotal) {
      iconeHoje = <FaArrowUp />
      corClasseOntem = 'text-danger' // Define a cor vermelha para ontem se hoje for maior
      corClasseHoje = 'text-success' // Define a cor verde para hoje se hoje for maior
    } else if (hoje.valorTotal < ontem.valorTotal) {
      iconeHoje = <FaArrowDown />
      corClasseOntem = 'text-success' // Define a cor verde para ontem se hoje for menor
      corClasseHoje = 'text-danger' // Define a cor vermelha para hoje se hoje for menor
    } else {
      corClasseOntem = 'text-primary' // Define a cor azul para ontem se os valores forem iguais
      corClasseHoje = 'text-primary' // Define a cor azul para hoje se os valores forem iguais
    }

    // Importe sua animação Lottie (substitua 'animacao.json' pelo caminho correto do seu arquivo JSON)

    return (
      <Card className="mb-3">
        <Card.Body>
          <h5 className="card-title">Comparativo</h5>
          <div className="d-flex justify-content-between">
            <div className="d-flex align-items-center">
              {iconeOntem}
              <p className={`mb-0 ml-2 ${corClasseOntem}`}>
                Ontem:{' '}
                {ontem.valorTotal
                  ? ontem.valorTotal.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                  : 'Valor Indisponível'}
              </p>
            </div>
            <div className="d-flex align-items-center">
              {iconeHoje}
              <p className={`mb-0 ml-2 ${corClasseHoje}`}>
                Hoje:{' '}
                {hoje.valorTotal
                  ? hoje.valorTotal.toLocaleString('pt-BR', {
                    style: 'currency',
                    currency: 'BRL',
                  })
                  : 'Valor Indisponível'}
              </p>
            </div>
          </div>
          <div className="mt-3">
            <Lottie
              animationData={animacaoLottie}
              height={25}
              width={25}
            />{' '}
            {/* Ajuste a altura e largura conforme necessário */}
          </div>
        </Card.Body>
      </Card>
    )
  }

  const getRandomColor = () => {
    const letters = '0123456789ABCDEF'
    let color = '#'
    for (let i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)]
    }
    return color
  }



  const ComparativoVendasCard = ({ informacoesVendas }) => {
    const canvasRef = useRef(null);
    const ontem = informacoesVendas.ontem;
    const hoje = informacoesVendas.hoje;

    const pedidosMaiorHoje = hoje.quantidadePedidos >= ontem.quantidadePedidos;
    const diferenca = hoje.quantidadePedidos - ontem.quantidadePedidos;
    const percentualMudanca = ontem.quantidadePedidos > 0
      ? ((diferenca / ontem.quantidadePedidos) * 100).toFixed(1)
      : 100;

    // Função para desenhar gráfico animado no canvas
    useEffect(() => {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');

      // Configurações do canvas
      canvas.width = 400;
      canvas.height = 200;

      const maxValue = Math.max(ontem.quantidadePedidos, hoje.quantidadePedidos) + 5;
      const barWidth = 80;
      const spacing = 120;

      let animationProgress = 0;

      const animate = () => {
        if (animationProgress < 1) {
          animationProgress += 0.02;

          // Limpar canvas
          ctx.clearRect(0, 0, canvas.width, canvas.height);

          // Gradientes
          const gradientOntem = ctx.createLinearGradient(0, 0, 0, canvas.height);
          gradientOntem.addColorStop(0, '#ff9a9e');
          gradientOntem.addColorStop(1, '#fecfef');

          const gradientHoje = ctx.createLinearGradient(0, 0, 0, canvas.height);
          gradientHoje.addColorStop(0, '#667eea');
          gradientHoje.addColorStop(1, '#764ba2');

          // Altura das barras com animação
          const alturaOntem = (ontem.quantidadePedidos / maxValue) * (canvas.height - 60) * animationProgress;
          const alturaHoje = (hoje.quantidadePedidos / maxValue) * (canvas.height - 60) * animationProgress;

          // Desenhar barra "Ontem"
          ctx.fillStyle = gradientOntem;
          ctx.fillRect(60, canvas.height - 40 - alturaOntem, barWidth, alturaOntem);

          // Desenhar barra "Hoje"
          ctx.fillStyle = gradientHoje;
          ctx.fillRect(60 + spacing, canvas.height - 40 - alturaHoje, barWidth, alturaHoje);

          // Labels
          ctx.fillStyle = '#64748b';
          ctx.font = 'bold 14px -apple-system, BlinkMacSystemFont, sans-serif';
          ctx.textAlign = 'center';
          ctx.fillText('Ontem', 60 + barWidth / 2, canvas.height - 10);
          ctx.fillText('Hoje', 60 + spacing + barWidth / 2, canvas.height - 10);

          // Valores
          ctx.fillStyle = '#1e293b';
          ctx.font = 'bold 16px -apple-system, BlinkMacSystemFont, sans-serif';
          ctx.fillText(
            Math.round(ontem.quantidadePedidos * animationProgress),
            60 + barWidth / 2,
            canvas.height - 50 - alturaOntem - 10
          );
          ctx.fillText(
            Math.round(hoje.quantidadePedidos * animationProgress),
            60 + spacing + barWidth / 2,
            canvas.height - 50 - alturaHoje - 10
          );

          requestAnimationFrame(animate);
        }
      };

      animate();
    }, [ontem.quantidadePedidos, hoje.quantidadePedidos]);

    return (
      <>
        <style>
          {`
            @keyframes slideInLeft {
              from {
                opacity: 0;
                transform: translateX(-30px);
              }
              to {
                opacity: 1;
                transform: translateX(0);
              }
            }
            
            @keyframes slideInRight {
              from {
                opacity: 0;
                transform: translateX(30px);
              }
              to {
                opacity: 1;
                transform: translateX(0);
              }
            }
            
            @keyframes bounceIn {
              0% {
                transform: scale(0.3);
                opacity: 0;
              }
              50% {
                transform: scale(1.05);
              }
              70% {
                transform: scale(0.9);
              }
              100% {
                transform: scale(1);
                opacity: 1;
              }
            }
            
            @keyframes float {
              0%, 100% {
                transform: translateY(0px);
              }
              50% {
                transform: translateY(-10px);
              }
            }
            
            @keyframes glow {
              0%, 100% {
                box-shadow: 0 0 20px rgba(102, 126, 234, 0.3);
              }
              50% {
                box-shadow: 0 0 30px rgba(102, 126, 234, 0.5);
              }
            }
            
            .metric-card {
              transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
            }
            
            .metric-card:hover {
              transform: translateY(-8px) scale(1.02);
            }
            
            .trend-indicator {
              animation: float 3s ease-in-out infinite;
            }
          `}
        </style>

        <div style={{
          // background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
          minHeight: '100vh',
          padding: '20px',
          fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif'
        }}>
          <div style={{
            maxWidth: '1200px',
            margin: '0 auto'
          }}>
            {/* Header Principal */}
            <div style={{
              textAlign: 'center',
              marginBottom: '40px',
              animation: 'bounceIn 0.8s ease'
            }}>
              <div style={{
                display: 'inline-flex',
                alignItems: 'center',
                gap: '15px',
                background: 'rgba(255, 255, 255, 0.95)',
                padding: '20px 40px',
                borderRadius: '50px',
                boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                backdropFilter: 'blur(20px)'
              }}>
                <BarChart3 size={32} color="#667eea" />
                <h1 style={{
                  margin: '0',
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  WebkitBackgroundClip: 'text',
                  WebkitTextFillColor: 'transparent',
                  fontSize: '2rem',
                  fontWeight: '800'
                }}>
                  Comparativo de Vendas
                </h1>
                <Zap size={28} color="#fbbf24" style={{ animation: 'float 2s ease-in-out infinite' }} />
              </div>
            </div>

            {/* Cards de Métricas */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
              gap: '25px',
              marginBottom: '40px'
            }}>
              {/* Card Ontem */}
              <div
                className="metric-card"
                style={{
                  background: 'linear-gradient(145deg, #ff9a9e, #fecfef)',
                  borderRadius: '24px',
                  padding: '30px',
                  color: 'white',
                  boxShadow: '0 15px 35px rgba(255, 154, 158, 0.3)',
                  animation: 'slideInLeft 0.6s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <div style={{
                  position: 'absolute',
                  top: '-20px',
                  right: '-20px',
                  width: '100px',
                  height: '100px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }}></div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '16px',
                    padding: '12px',
                    backdropFilter: 'blur(10px)'
                  }}>
                    <Calendar size={24} />
                  </div>
                  <h3 style={{ margin: '0', fontSize: '1.3rem', fontWeight: '700' }}>Ontem</h3>
                </div>

                <div style={{ fontSize: '3rem', fontWeight: '900', marginBottom: '10px' }}>
                  {ontem.quantidadePedidos}
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '1rem',
                  opacity: '0.9'
                }}>
                  <ShoppingBag size={18} />
                  pedidos realizados
                </div>
              </div>

              {/* Card Hoje */}
              <div
                className="metric-card"
                style={{
                  background: 'linear-gradient(145deg, #667eea, #764ba2)',
                  borderRadius: '24px',
                  padding: '30px',
                  color: 'white',
                  boxShadow: '0 15px 35px rgba(102, 126, 234, 0.4)',
                  animation: 'slideInRight 0.6s ease',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <div style={{
                  position: 'absolute',
                  top: '-20px',
                  right: '-20px',
                  width: '100px',
                  height: '100px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }}></div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                  <div style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '16px',
                    padding: '12px',
                    backdropFilter: 'blur(10px)'
                  }}>
                    <Zap size={24} />
                  </div>
                  <h3 style={{ margin: '0', fontSize: '1.3rem', fontWeight: '700' }}>Hoje</h3>
                </div>

                <div style={{ fontSize: '3rem', fontWeight: '900', marginBottom: '10px' }}>
                  {hoje.quantidadePedidos}
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  fontSize: '1rem',
                  opacity: '0.9'
                }}>
                  <ShoppingBag size={18} />
                  pedidos até agora
                </div>
              </div>

              {/* Card de Performance */}
              <div
                className="metric-card"
                style={{
                  background: pedidosMaiorHoje
                    ? 'linear-gradient(145deg, #10b981, #34d399)'
                    : 'linear-gradient(145deg, #ef4444, #f87171)',
                  borderRadius: '24px',
                  padding: '30px',
                  color: 'white',
                  boxShadow: pedidosMaiorHoje
                    ? '0 15px 35px rgba(16, 185, 129, 0.3)'
                    : '0 15px 35px rgba(239, 68, 68, 0.3)',
                  animation: 'bounceIn 0.8s ease 0.3s both',
                  position: 'relative',
                  overflow: 'hidden'
                }}
              >
                <div style={{
                  position: 'absolute',
                  top: '-20px',
                  right: '-20px',
                  width: '100px',
                  height: '100px',
                  background: 'rgba(255, 255, 255, 0.1)',
                  borderRadius: '50%'
                }}></div>

                <div style={{ display: 'flex', alignItems: 'center', gap: '15px', marginBottom: '20px' }}>
                  <div className="trend-indicator" style={{
                    background: 'rgba(255, 255, 255, 0.2)',
                    borderRadius: '16px',
                    padding: '12px',
                    backdropFilter: 'blur(10px)'
                  }}>
                    {pedidosMaiorHoje ? <TrendingUp size={24} /> : <TrendingDown size={24} />}
                  </div>
                  <h3 style={{ margin: '0', fontSize: '1.3rem', fontWeight: '700' }}>Performance</h3>
                </div>

                <div style={{
                  fontSize: '2.5rem',
                  fontWeight: '900',
                  marginBottom: '10px',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '10px'
                }}>
                  {Math.abs(percentualMudanca)}%
                  {pedidosMaiorHoje ? <TrendingUp size={32} /> : <TrendingDown size={32} />}
                </div>

                <div style={{ fontSize: '1rem', opacity: '0.9' }}>
                  {pedidosMaiorHoje ? 'Crescimento' : 'Redução'} vs ontem
                </div>
              </div>
            </div>

            {/* Card do Gráfico Principal */}
            <div style={{
              background: 'rgba(255, 255, 255, 0.95)',
              borderRadius: '32px',
              padding: '40px',
              boxShadow: '0 25px 50px rgba(0, 0, 0, 0.1)',
              backdropFilter: 'blur(20px)',
              animation: 'glow 3s ease-in-out infinite'
            }}>
              {/* Header do Gráfico */}
              <div style={{
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'space-between',
                marginBottom: '30px',
                flexWrap: 'wrap',
                gap: '20px'
              }}>
                <div>
                  <h2 style={{
                    margin: '0 0 8px 0',
                    fontSize: '1.8rem',
                    fontWeight: '800',
                    color: '#1e293b'
                  }}>
                    Análise Comparativa
                  </h2>
                  <p style={{
                    margin: '0',
                    color: '#64748b',
                    fontSize: '1.1rem'
                  }}>
                    Visualização detalhada do desempenho
                  </p>
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '15px',
                  background: pedidosMaiorHoje
                    ? 'linear-gradient(135deg, #d1fae5, #a7f3d0)'
                    : 'linear-gradient(135deg, #fecaca, #fca5a5)',
                  padding: '12px 20px',
                  borderRadius: '50px',
                  border: pedidosMaiorHoje
                    ? '2px solid #10b981'
                    : '2px solid #ef4444'
                }}>
                  <span style={{
                    fontSize: '1.1rem',
                    fontWeight: '700',
                    color: pedidosMaiorHoje ? '#065f46' : '#7f1d1d'
                  }}>
                    {diferenca > 0 ? '+' : ''}{diferenca} pedidos
                  </span>
                  <ArrowRight
                    size={20}
                    color={pedidosMaiorHoje ? '#10b981' : '#ef4444'}
                    style={{ animation: 'float 2s ease-in-out infinite' }}
                  />
                </div>
              </div>

              {/* Container do Gráfico */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                minHeight: '300px',
                background: 'linear-gradient(135deg, #f8fafc, #f1f5f9)',
                borderRadius: '20px',
                padding: '30px',
                position: 'relative'
              }}>
                <canvas
                  ref={canvasRef}
                  style={{
                    maxWidth: '100%',
                    height: 'auto',
                    filter: 'drop-shadow(0 4px 20px rgba(0, 0, 0, 0.1))'
                  }}
                />

                {/* Decoração de fundo */}
                <div style={{
                  position: 'absolute',
                  top: '20px',
                  right: '20px',
                  width: '60px',
                  height: '60px',
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  borderRadius: '50%',
                  opacity: '0.1'
                }}></div>

                <div style={{
                  position: 'absolute',
                  bottom: '20px',
                  left: '20px',
                  width: '40px',
                  height: '40px',
                  background: 'linear-gradient(135deg, #ff9a9e, #fecfef)',
                  borderRadius: '50%',
                  opacity: '0.1'
                }}></div>
              </div>

              {/* Legenda Moderna */}
              <div style={{
                display: 'flex',
                justifyContent: 'center',
                gap: '40px',
                marginTop: '30px',
                flexWrap: 'wrap'
              }}>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  background: 'linear-gradient(135deg, #ff9a9e, #fecfef)',
                  padding: '12px 20px',
                  borderRadius: '50px',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 8px 25px rgba(255, 154, 158, 0.3)'
                }}>
                  <div style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    background: 'white'
                  }}></div>
                  Ontem: {ontem.quantidadePedidos}
                </div>

                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '12px',
                  background: 'linear-gradient(135deg, #667eea, #764ba2)',
                  padding: '12px 20px',
                  borderRadius: '50px',
                  color: 'white',
                  fontWeight: '600',
                  boxShadow: '0 8px 25px rgba(102, 126, 234, 0.3)'
                }}>
                  <div style={{
                    width: '12px',
                    height: '12px',
                    borderRadius: '50%',
                    background: 'white'
                  }}></div>
                  Hoje: {hoje.quantidadePedidos}
                </div>
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };


  // Dados de exemplo para demonstração
  // const dadosVendasFull = [
  //   {
  //     APELIDO: "Loja Central",
  //     NUM_PEDIDOS: 145,
  //     TOTAL_VALOR: 28750.50
  //   },
  //   {
  //     APELIDO: "Filial Norte", 
  //     NUM_PEDIDOS: 98,
  //     TOTAL_VALOR: 19240.30
  //   },
  //   {
  //     APELIDO: "E-commerce",
  //     NUM_PEDIDOS: 267,
  //     TOTAL_VALOR: 45680.90
  //   },
  //   {
  //     APELIDO: "Marketplace",
  //     NUM_PEDIDOS: 189,
  //     TOTAL_VALOR: 32150.75
  //   },
  //   {
  //     APELIDO: "Atacado",
  //     NUM_PEDIDOS: 76,
  //     TOTAL_VALOR: 15680.20
  //   },
  //   {
  //     APELIDO: "Outlet",
  //     NUM_PEDIDOS: 234,
  //     TOTAL_VALOR: 38920.45
  //   }
  // ];

  function FulfillmentDashboard() {
    const totalPedidos = dadosVendasFull.reduce((acc, venda) => acc + venda.NUM_PEDIDOS, 0);
    const totalVendas = dadosVendasFull.reduce((acc, venda) => acc + venda.TOTAL_VALOR, 0);

    return (
      <div style={{
        background: 'rgba(255, 255, 255, 255)',

        minHeight: '100vh',
        padding: '24px'
      }}>
        <div style={{ maxWidth: '1400px', margin: '0 auto' }}>

          {/* Header */}
          <div style={{
            background: 'rgba(255, 255, 255, 0.95)',
            backdropFilter: 'blur(20px)',
            borderRadius: '20px',
            padding: '32px',
            marginBottom: '32px',
            boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
            border: '1px solid rgba(255, 255, 255, 0.2)'
          }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px', marginBottom: '24px' }}>
              <div style={{
                background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                padding: '12px',
                borderRadius: '16px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center'
              }}>
                <BarChart3 size={32} style={{ color: 'white' }} />
              </div>
              <h1 style={{
                margin: 0,
                fontSize: '32px',
                fontWeight: '700',
                color: '#1e293b',
                background: 'linear-gradient(135deg, #4f46e5, #7c3aed)',
                WebkitBackgroundClip: 'text',
                WebkitTextFillColor: 'transparent'
              }}>
                Dashboard de Vendas Fulfillment
              </h1>
            </div>

            {/* Cards Resumo */}
            <div style={{
              display: 'grid',
              gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))',
              gap: '20px'
            }}>
              <div style={{
                background: 'linear-gradient(135deg, #10b981, #059669)',
                padding: '24px',
                borderRadius: '16px',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                boxShadow: '0 10px 30px rgba(16, 185, 129, 0.3)'
              }}>
                <ShoppingCart size={36} />
                <div>
                  <p style={{ margin: '0 0 4px 0', fontSize: '14px', opacity: 0.9, color: 'white' }}>Total de Pedidos</p>
                  <p style={{ margin: 0, fontSize: '28px', fontWeight: '700', color: 'white' }}>
                    {totalPedidos.toLocaleString()}
                  </p>
                </div>
              </div>

              <div style={{
                background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                padding: '24px',
                borderRadius: '16px',
                color: 'white',
                display: 'flex',
                alignItems: 'center',
                gap: '16px',
                boxShadow: '0 10px 30px rgba(59, 130, 246, 0.3)'
              }}>
                <DollarSign size={36} />
                <div>
                  <p style={{ margin: '0 0 4px 0', fontSize: '14px', opacity: 0.9, color: 'white' }}>Total de Vendas</p>
                  <p style={{ margin: 0, fontSize: '28px', fontWeight: '700', color: 'white' }}>
                    {totalVendas.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
                  </p>
                </div>
              </div>
            </div>

          </div>

          {/* Cards das Lojas */}
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fill, minmax(350px, 1fr))',
            gap: '24px'
          }}>
            {dadosVendasFull.map((venda, index) => (
              <div
                key={index}
                style={{
                  background: 'rgba(255, 255, 255, 0.95)',
                  backdropFilter: 'blur(20px)',
                  borderRadius: '20px',
                  padding: '28px',
                  boxShadow: '0 20px 40px rgba(0, 0, 0, 0.1)',
                  border: '1px solid rgba(255, 255, 255, 0.2)',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  position: 'relative',
                  overflow: 'hidden'
                }}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-8px)';
                  e.currentTarget.style.boxShadow = '0 30px 60px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 20px 40px rgba(0, 0, 0, 0.1)';
                }}
              >
                {/* Background Pattern */}
                <div style={{
                  position: 'absolute',
                  top: 0,
                  right: 0,
                  width: '100px',
                  height: '100px',
                  background: 'linear-gradient(135deg, rgba(79, 70, 229, 0.1), rgba(124, 58, 237, 0.1))',
                  borderRadius: '50%',
                  transform: 'translate(30px, -30px)'
                }}></div>

                <div style={{ position: 'relative', zIndex: 1 }}>
                  {/* Header do Card */}
                  <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: '24px' }}>
                    <h3 style={{
                      margin: 0,
                      fontSize: '22px',
                      fontWeight: '600',
                      color: '#1e293b'
                    }}>
                      {venda.APELIDO}
                    </h3>
                    <div style={{
                      background: 'linear-gradient(135deg, #f59e0b, #d97706)',
                      padding: '10px',
                      borderRadius: '12px',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center'
                    }}>
                      <Package size={24} style={{ color: 'white' }} />
                    </div>
                  </div>

                  {/* Métricas */}
                  <div style={{ marginBottom: '20px' }}>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      marginBottom: '16px',
                      padding: '12px',
                      background: 'rgba(16, 185, 129, 0.1)',
                      borderRadius: '12px'
                    }}>
                      <ShoppingCart size={20} style={{ color: '#059669' }} />
                      <span style={{ fontSize: '14px', color: '#64748b' }}>Pedidos:</span>
                      <span style={{ fontSize: '20px', fontWeight: '700', color: '#059669', marginLeft: 'auto' }}>
                        {venda.NUM_PEDIDOS}
                      </span>
                    </div>

                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '12px',
                      padding: '12px',
                      background: 'rgba(59, 130, 246, 0.1)',
                      borderRadius: '12px'
                    }}>
                      <DollarSign size={20} style={{ color: '#1d4ed8' }} />
                      <span style={{ fontSize: '14px', color: '#64748b' }}>Vendas:</span>
                      <span style={{ fontSize: '20px', fontWeight: '700', color: '#1d4ed8', marginLeft: 'auto' }}>
                        {venda.TOTAL_VALOR.toLocaleString('pt-BR', {
                          style: 'currency',
                          currency: 'BRL',
                        })}
                      </span>
                    </div>
                  </div>

                  {/* Status */}
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    gap: '8px',
                    padding: '12px',
                    background: 'rgba(16, 185, 129, 0.1)',
                    borderRadius: '12px'
                  }}>
                    <TrendingUp size={18} style={{ color: '#059669' }} />
                    <span style={{ color: '#059669', fontWeight: '600', fontSize: '14px' }}>Ativo</span>
                    <Award size={18} style={{ color: '#f59e0b' }} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    );
  }






  async function sendTokenToEndpoint(mytoken) {
    const endpoint = `/api/token/${localStorage.idconta || '514066249'}`
    console.log({ token: mytoken })

    try {
      const response = await apinode.post(endpoint, { token: mytoken })

      if (response.status === 200) {
        console.log('Token updated successfully')
      } else if (response.status === 201) {
        console.log('Token inserted successfully')
      } else {
        console.log('Unexpected response:', response.status, response.data)
      }
    } catch (error) {
      console.error('Error while accessing the endpoint:', error.message)
    }
  }

  function ConsumirComparativo() {
    apinode
      .get(`/informacoes-vendas/${localStorage.idconta}`)
      .then((response) => {
        const dadosAPI = response.data
        setDadosVendasComparativo(dadosAPI)
        console.log('teste', response.data)
      })
      .catch((error) => {
        console.error('Erro ao buscar dados da API: ', error)
      })
  }

  function consumirMetricas() {
    apinode
      .get(`/buscar-dados/${localStorage.idconta}`)
      .then((response) => {
        if (response.status === 200) {
          // O status é 202 (Accepted), continue com o processamento
          const dadosAPI = response.data
          console.log('metricas', response.data)
          setMetricas(dadosAPI)
        } else {
          // Qualquer outro status é tratado como erro
          console.error('Resposta inesperada da API. Status:', response.status)
        }
      })
      .catch((error) => {
        console.error('Erro ao buscar dados da API: ', error)
      })
  }

  useEffect(() => {
    const localTimeZone = 'America/Sao_Paulo' // Substitua pelo seu fuso horário local
    const now = new Date() // Obtém a data e hora atual no fuso horário UTC

    // Converte a data e hora atual para o fuso horário local
    const localDate = utcToZonedTime(now, localTimeZone)
    const dataFormatada = format(new Date(localDate), 'yyyy-MM-dd')

    // Obtém a data e hora atual no fuso horário local do cliente usando Luxon
    const dataHoraLocal = DateTime.local() // Isso obtém a data e hora local atual

    // Formata a data e hora local em um formato específico (por exemplo, 'yyyy-MM-dd')
    const formato = 'yyyy-MM-dd'
    const dataHoraFormatada = DateTime.fromISO(dataHoraLocal)

    console.log('Data e hora local:', dataHoraFormatada)

    // setSelectedDate(dataFormatada);
    consumirMetricas()
    ConsumirComparativo()
    CosumirPorloja(dataHoraFormatada) // Chama a função aqui
    ConsumirFull(dataHoraFormatada)
    VendasporAno(anoSelecionado)
    // fetchPerguntas()
    /*     const registerServiceWorker = async () => {
      if ('serviceWorker' in navigator) {
        try {
          const registration = await navigator.serviceWorker.register(
            '/firebase-messaging-sw.js',
            {
              scope: '/',
            },
          )
          console.log('Service Worker registrado com sucesso:', registration)

          const messagingInstance = getMessaging()
          try {
            const currentToken = await getToken(messagingInstance, {
              vapidKey:
                'BPtwWDViDttPHUnKLSWSeBhxO9JXevOP8EQ1nW2jKHfJCtSsb7s8qxAfjnLfXehT_5xTE-d64SiqT8N6eZCuOyU',
            })
            if (currentToken) {
              console.log(currentToken)
              sendTokenToEndpoint(currentToken)
              // ...
            } else {
              // ...
            }
          } catch (err) {
            // ...
          }
        } catch (error) {
          console.error('Error registering Service Worker:', error)
        }
      }
    }
 */
    fetchData(dataHoraFormatada)
    console.log('pesquisando por data', localDate)
    // registerServiceWorker()
  }, [])

  const fetchData = async (date) => {
    try {
      // Formate a data para o formato "YYYY-MM-DD"
      const dataFormatada = format(new Date(date), 'yyyy-MM-dd')

      const response = await apinode.get('/inventario/dashboard', {
        params: {
          conta: localStorage.idconta,
          data: dataFormatada,
        },
      })

      console.log(response.data.totalDiario)
      setDadosDashboard(response.data)
      setTotalDiario(response.data.totalDiario)
      setIsLoading(false)
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error)
      setIsLoading(false)
    }
  }

  const CosumirPorloja = async (data) => {
    try {
      const response = await apinode.get(
        `/auth/vendasporloja/${localStorage.idconta}`,
        {
          params: {
            data: data,
          },
        },
      )
      setDadosVendas(response.data)
      console.log(response.data)
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error)
    }
  }

  const ConsumirFull = async (data) => {
    try {
      const response = await apinode.get(
        `/auth/vendasporlojafull/${localStorage.idconta}`,
        {
          params: {
            data: data,
          },
        },
      )
      setDadosVendasFull(response.data)
      console.log(response.data)
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error)
    }
  }

  const VendasporAno = async (ano) => {
    try {
      setIsLoadingAno(true) // Defina isLoadingAno como true antes da solicitação
      const response = await apinode.get(
        `/vendasporano/${ano}/${localStorage.idconta}`,
      )
      setDados(response.data)
      setIsLoadingAno(false) // Defina isLoadingAno como false após a conclusão da solicitação
      console.log(response.data)
    } catch (error) {
      console.error('Erro ao buscar dados da API:', error)
      setIsLoadingAno(false) // Certifique-se de definir isLoadingAno como false em caso de erro
    }
  }


  // Estilos CSS inline para garantir que funcione
  const styles = {
    container: {
      minHeight: '100vh',
      background: 'linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%)',
      padding: '1rem'
    },
    card: {
      borderRadius: '1.5rem',
      border: 'none',
      boxShadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 10px 10px -5px rgba(0, 0, 0, 0.04)'
    },
    headerIcon: {
      padding: '12px',
      background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
      borderRadius: '50%',
      color: 'white',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      boxShadow: '0 4px 14px 0 rgba(59, 130, 246, 0.4)'
    },
    title: {
      background: 'linear-gradient(135deg, #374151 0%, #6b7280 100%)',
      WebkitBackgroundClip: 'text',
      WebkitTextFillColor: 'transparent',
      backgroundClip: 'text',
      fontSize: '2rem',
      fontWeight: 'bold',
      margin: 0
    },
    divider: {
      width: '6rem',
      height: '4px',
      background: 'linear-gradient(135deg, #3b82f6 0%, #8b5cf6 100%)',
      borderRadius: '2px',
      margin: '0 auto'
    },
    summaryCard: (color) => ({
      border: `1px solid ${color}40`,
      borderRadius: '12px',
      padding: '1rem',
      background: `linear-gradient(135deg, ${color}08 0%, ${color}15 100%)`
    }),
    table: {
      background: 'white',
      borderRadius: '1rem',
      border: '1px solid #e5e7eb',
      overflow: 'hidden',
      boxShadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1)'
    },
    thead: {
      background: 'linear-gradient(135deg, #f9fafb 0%, #f3f4f6 100%)'
    },
    badge: (color) => ({
      background: `linear-gradient(135deg, ${color} 0%, ${color}dd 100%)`,
      color: 'white',
      padding: '8px 16px',
      borderRadius: '20px',
      fontWeight: 'bold',
      fontSize: '0.875rem',
      boxShadow: `0 2px 8px ${color}40`
    }),
    progressBar: {
      width: '48px',
      height: '8px',
      backgroundColor: '#e5e7eb',
      borderRadius: '4px',
      overflow: 'hidden'
    },
    progressFill: (color, width) => ({
      height: '100%',
      backgroundColor: color,
      borderRadius: '4px',
      width: `${width}%`,
      transition: 'all 0.3s ease'
    })
  };

  const TabelaVendas = ({ totalDiario: dados = totalDiario }) => {
    // Função para calcular o total de uma coluna específica
    const calcularTotal = (coluna) => {
      return dados.reduce((total, item) => total + item[coluna], 0);
    };

    const totalVendas = calcularTotal('TOTALVENDASDIA');
    const totalCanceladas = calcularTotal('TOTALVENDASCANCELADAS');
    const taxaCancelamento = ((totalCanceladas / totalVendas) * 100).toFixed(2);

    return (
      <div style={styles.container}>
        <div className="card" style={styles.card}>
          <div className="card-body p-4">
            {/* Header modernizado */}
            <div className="text-center mb-4">
              <div className="d-flex align-items-center justify-content-center gap-3 mb-3">
                <div style={styles.headerIcon}>
                  <Calendar size={24} />
                </div>
                <h2 style={styles.title}>
                  Total Diário de Vendas
                </h2>
              </div>
              <div style={styles.divider}></div>
            </div>

            {/* Cards de resumo */}
            <div className="row mb-4">
              <div className="col-md-4 mb-3">
                <div style={styles.summaryCard('#10b981')}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1" style={{ color: '#065f46', fontSize: '0.875rem', fontWeight: '500' }}>Total Vendas</p>
                      <p className="mb-0" style={{ color: '#047857', fontSize: '1.5rem', fontWeight: 'bold' }}>{formatarValorReal(totalVendas)}</p>
                    </div>
                    <TrendingUp color="#10b981" size={32} />
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div style={styles.summaryCard('#ef4444')}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1" style={{ color: '#7f1d1d', fontSize: '0.875rem', fontWeight: '500' }}>Total Canceladas</p>
                      <p className="mb-0" style={{ color: '#991b1b', fontSize: '1.5rem', fontWeight: 'bold' }}>{formatarValorReal(totalCanceladas)}</p>
                    </div>
                    <TrendingDown color="#ef4444" size={32} />
                  </div>
                </div>
              </div>

              <div className="col-md-4 mb-3">
                <div style={styles.summaryCard('#f97316')}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <p className="mb-1" style={{ color: '#7c2d12', fontSize: '0.875rem', fontWeight: '500' }}>Taxa Cancelamento</p>
                      <p className="mb-0" style={{ color: '#9a3412', fontSize: '1.5rem', fontWeight: 'bold' }}>{taxaCancelamento}%</p>
                    </div>
                    <AlertCircle color="#f97316" size={32} />
                  </div>
                </div>
              </div>
            </div>

            {dados && dados.length > 0 ? (
              <div style={styles.table}>
                <table className="table table-hover mb-0">
                  <thead style={styles.thead}>
                    <tr>
                      <th className="border-bottom-2 p-3" style={{ color: '#374151', fontWeight: '600' }}>
                        <div className="d-flex align-items-center gap-2">
                          <Calendar size={16} color="#6b7280" />
                          Dia
                        </div>
                      </th>
                      <th className="border-bottom-2 p-3" style={{ color: '#374151', fontWeight: '600' }}>
                        <div className="d-flex align-items-center gap-2">
                          <TrendingUp size={16} color="#10b981" />
                          Total Vendas Dia
                        </div>
                      </th>
                      <th className="border-bottom-2 p-3" style={{ color: '#374151', fontWeight: '600' }}>
                        <div className="d-flex align-items-center gap-2">
                          <TrendingDown size={16} color="#ef4444" />
                          Total Vendas Canceladas
                        </div>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {dados.map((item, index) => (
                      <tr
                        key={item.DIA}
                        style={{ borderBottom: '1px solid #e5e7eb' }}
                      >
                        <td className="p-3" style={{ fontWeight: '500', color: '#374151' }}>
                          <div className="d-flex align-items-center gap-2">
                            <div style={{ width: '8px', height: '8px', backgroundColor: '#60a5fa', borderRadius: '50%' }}></div>
                            {(() => {
                              try {
                                // Tenta diferentes formatos de data
                                let dataFormatada;
                                if (item.DIA.includes('/')) {
                                  // Formato DD/MM/YYYY ou MM/DD/YYYY
                                  const partes = item.DIA.split('/');
                                  if (partes.length === 3) {
                                    dataFormatada = new Date(partes[2], partes[1] - 1, partes[0]);
                                  }
                                } else if (item.DIA.includes('-')) {
                                  // Formato YYYY-MM-DD
                                  dataFormatada = new Date(item.DIA + 'T00:00:00');
                                } else {
                                  // Tenta criar diretamente
                                  dataFormatada = new Date(item.DIA);
                                }

                                return dataFormatada && !isNaN(dataFormatada)
                                  ? dataFormatada.toLocaleDateString('pt-BR')
                                  : item.DIA; // Se não conseguir formatar, mostra o valor original
                              } catch (error) {
                                return item.DIA; // Em caso de erro, mostra o valor original
                              }
                            })()}
                          </div>
                        </td>
                        <td className="p-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <span style={{ color: '#047857', fontWeight: '600' }}>
                              {formatarValorReal(item.TOTALVENDASDIA)}
                            </span>
                            <div style={styles.progressBar}>
                              <div
                                style={styles.progressFill('#10b981', (item.TOTALVENDASDIA / Math.max(...dados.map(d => d.TOTALVENDASDIA))) * 100)}
                              />
                            </div>
                          </div>
                        </td>
                        <td className="p-3">
                          <div className="d-flex align-items-center justify-content-between">
                            <span style={{ color: '#991b1b', fontWeight: '600' }}>
                              {formatarValorReal(item.TOTALVENDASCANCELADAS)}
                            </span>
                            <div style={styles.progressBar}>
                              <div
                                style={styles.progressFill('#ef4444', (item.TOTALVENDASCANCELADAS / Math.max(...dados.map(d => d.TOTALVENDASCANCELADAS))) * 100)}
                              />
                            </div>
                          </div>
                        </td>
                      </tr>
                    ))}

                    {/* Linha de totais modernizada */}
                    <tr style={{ background: 'linear-gradient(135deg, #f3f4f6 0%, #e5e7eb 100%)', fontWeight: 'bold' }}>
                      <td className="p-3" style={{ color: '#374151', borderTop: '2px solid #d1d5db' }}>
                        <div className="d-flex align-items-center gap-2">
                          <DollarSign size={16} color="#6b7280" />
                          <span style={{ fontSize: '1.125rem' }}>TOTAIS</span>
                        </div>
                      </td>
                      <td className="p-3" style={{ borderTop: '2px solid #d1d5db' }}>
                        <span style={styles.badge('#10b981')}>
                          {formatarValorReal(calcularTotal('TOTALVENDASDIA'))}
                        </span>
                      </td>
                      <td className="p-3" style={{ borderTop: '2px solid #d1d5db' }}>
                        <span style={styles.badge('#ef4444')}>
                          {formatarValorReal(calcularTotal('TOTALVENDASCANCELADAS'))}
                        </span>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="text-center py-5">
                <div className="d-flex flex-column align-items-center gap-3">
                  <div className="p-4 rounded-circle" style={{ backgroundColor: '#f3f4f6' }}>
                    <AlertCircle size={48} color="#9ca3af" />
                  </div>
                  <p style={{ color: '#6b7280', fontSize: '1.125rem' }}>Nenhum dado disponível.</p>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };



  function AccountStatistics() {
    return (
      <div className="container-p3">
        <Card>
          <Card.Body>
            <h2>Estatísticas das Contas</h2>

            <section
              style={{
                display: 'flex',
                flexWrap: 'wrap',
                gap: 10,
                justifyContent: 'center',
              }}
            >
              {statistics.map((stat) => (
                <article
                  className="stat-card"
                  style={{
                    width: 300,
                    borderRadius: 20,
                    padding: 20,
                    border: '1px solid rgba(0,0,0,0.3)',
                  }}
                >
                  <header
                    style={{
                      height: 35,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'space-between',
                      paddingLeft: 10,
                    }}
                  >
                    <span
                      style={{
                        fontWeight: 'bold',
                      }}
                    >
                      {stat.account}
                    </span>

                    <AwardFill
                      size={25}
                      color={
                        stat.level_partner === 'gold' ? ' #FFD700' : '#dbd9d7'
                      }
                    />
                  </header>

                  <main>
                    <p
                      style={{
                        fontSize: 13,
                      }}
                    >
                      <strong>{stat.sales}</strong> vendas
                    </p>

                    <p
                      style={{
                        fontSize: 13,
                      }}
                    >
                      <strong>{stat.percentage_claims}</strong> reclamações
                    </p>

                    <p
                      style={{
                        fontSize: 13,
                      }}
                    >
                      Representam <strong>{stat.total_claims}</strong> das suas
                      reclamações
                    </p>

                    <p
                      style={{
                        fontSize: 13,
                      }}
                    >
                      <strong>{stat.percentage_delayed}</strong> atrasos
                    </p>

                    <p
                      style={{
                        fontSize: 13,
                      }}
                    >
                      Representam <strong>{stat.total_delayed}</strong> dos seus
                      atrasos
                    </p>

                    <p
                      style={{
                        fontSize: 13,
                      }}
                    >
                      <strong>{stat.percentage_canceled}</strong> cancelados
                    </p>

                    <p
                      style={{
                        fontSize: 13,
                      }}
                    >
                      Representam <strong>{stat.total_canceled}</strong> das
                      suas canceladas
                    </p>
                  </main>
                </article>
              ))}
            </section>
          </Card.Body>
        </Card>
      </div>
    )
  }


  const SalesRanking = () => {
    const [animatedValues, setAnimatedValues] = useState({});
    const [isVisible, setIsVisible] = useState(false);

    // Garante array mesmo se dadosVendas ainda não estiver pronto
    const vendas = Array.isArray(dadosVendas) ? dadosVendas : [];

    // Evita mutar o array original
    const sortedSalesData = vendas.slice().sort((a, b) => (b?.NUM_PEDIDOS || 0) - (a?.NUM_PEDIDOS || 0));
    const maxSales = sortedSalesData[0]?.NUM_PEDIDOS || 0;

    // Animação de entrada dos valores
    useEffect(() => {
      setIsVisible(true);
      const timeouts = [];
      const start = setTimeout(() => {
        sortedSalesData.forEach((entry, index) => {
          const t = setTimeout(() => {
            setAnimatedValues((prev) => ({
              ...prev,
              [entry.APELIDO]: entry.NUM_PEDIDOS || 0,
            }));
          }, index * 150);
          timeouts.push(t);
        });
      }, 300);

      return () => {
        clearTimeout(start);
        timeouts.forEach(clearTimeout);
      };
    }, [vendas.length]); // reanima se chegar dado novo

    // Estilo por colocação
    const getRankPosition = (index) => {
      switch (index) {
        case 0:
          return {
            label: "1º",
            gradient: "linear-gradient(135deg, #FFD700 0%, #FFA500 100%)",
            trophyBg: "linear-gradient(45deg, #FFD700, #ffea70)",
          };
        case 1:
          return {
            label: "2º",
            gradient: "linear-gradient(135deg, #C0C0C0 0%, #A8A8A8 100%)",
            trophyBg: "linear-gradient(45deg, #C0C0C0, #d9d9d9)",
          };
        case 2:
          return {
            label: "3º",
            gradient: "linear-gradient(135deg, #CD7F32 0%, #B8860B 100%)",
            trophyBg: "linear-gradient(45deg, #cd7f32, #a97142)",
          };
        default:
          return {
            label: `${index + 1}º`,
            gradient: "linear-gradient(135deg, #64748b 0%, #475569 100%)",
            trophyBg: null,
          };
      }
    };

    const renderTrophy = (bg, size) => (
      <FaTrophy style={{ background: bg, WebkitBackgroundClip: "text", color: "transparent", fontSize: size }} />
    );

    const getProgressColor = (percentage) => {
      if (percentage >= 80) return "#10b981";
      if (percentage >= 60) return "#3b82f6";
      if (percentage >= 40) return "#f59e0b";
      if (percentage >= 20) return "#ef4444";
      return "#6b7280";
    };

    return (
      <>
        <style>{`
          @keyframes slideInUp { from { opacity: 0; transform: translateY(30px);} to { opacity:1; transform:translateY(0);} }
          @keyframes slideInLeft { from { opacity: 0; transform: translateX(-50px);} to { opacity:1; transform:translateX(0);} }
          @keyframes slideInRight { from { opacity: 0; transform: translateX(50px);} to { opacity:1; transform:translateX(0);} }
          @keyframes progressFill { from { width: 0%; } }
          .ranking-card { transition: all .3s ease; cursor: pointer; }
          .ranking-card:hover { transform: translateY(-4px); box-shadow: 0 20px 40px rgba(0,0,0,.1); }
          .progress-bar-animated { transition: width 2s cubic-bezier(.4,0,.2,1); animation: progressFill 2s ease-out; }
          .podium-item { transition: all .3s ease; }
          .podium-item:hover { transform: translateY(-8px); }
        `}</style>

        <div style={{ minHeight: "100vh", padding: "24px", fontFamily: '-apple-system,BlinkMacSystemFont,"Segoe UI",Roboto,sans-serif', background: "#fafafa" }}>
          <div style={{ maxWidth: "1200px", margin: "0 auto" }}>
            {/* Header */}
            <div style={{ textAlign: "center", marginBottom: "48px", animation: isVisible ? "slideInUp .6s ease" : "none" }}>
              <h1 style={{ fontSize: "2.5rem", fontWeight: 300, color: "#1a1a1a", margin: "0 0 8px 0", letterSpacing: "-.02em" }}>
                Ranking de Vendas
              </h1>
              <p style={{ fontSize: "1.1rem", color: "#666", margin: 0, fontWeight: 400 }}>
                Performance diária das lojas virtuais
              </p>
            </div>

            {/* Pódio */}
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "1fr 1.2fr 1fr",
                gap: "16px",
                alignItems: "end",
                maxWidth: "800px",
                margin: "0 auto 48px auto",
              }}
            >
              {[
                { idx: 1, height: "180px", anim: "slideInLeft", delay: 0.2, size: 32 }, // 2º
                { idx: 0, height: "240px", anim: "slideInUp", delay: 0.4, size: 48 },  // 1º
                { idx: 2, height: "160px", anim: "slideInRight", delay: 0.2, size: 28 },// 3º
              ].map((p, i) => {
                const place = sortedSalesData[p.idx] || {};
                const rank = getRankPosition(p.idx);
                const isLeader = p.idx === 0;

                return (
                  <div
                    key={p.idx}
                    className="podium-item"
                    style={{
                      background: "white",
                      borderRadius: isLeader ? "20px" : "16px",
                      padding: isLeader ? "32px 24px" : "24px 20px",
                      textAlign: "center",
                      height: p.height,
                      display: "flex",
                      flexDirection: "column",
                      justifyContent: "space-between",
                      boxShadow: isLeader ? "0 8px 32px rgba(255, 215, 0, 0.15)" : "0 4px 20px rgba(0,0,0,.08)",
                      border: isLeader ? "2px solid #FFD700" : "1px solid #f0f0f0",
                      animation: isVisible ? `${p.anim} .8s ease ${p.delay}s both` : "none",
                      position: "relative",
                    }}
                  >
                    {/* Selo/posição */}
                    <div style={{ position: "absolute", top: isLeader ? 20 : 16, right: isLeader ? 20 : 16 }}>
                      <div
                        style={{
                          background: isLeader ? "#FFD700" : "transparent",
                          border: isLeader ? "none" : "0",
                          color: isLeader ? "white" : "#999",
                          fontSize: isLeader ? 10 : 12,
                          padding: isLeader ? "4px 8px" : 0,
                          borderRadius: isLeader ? 12 : 0,
                          fontWeight: 700,
                        }}
                      >
                        {isLeader ? "LÍDER" : rank.label}
                      </div>
                    </div>

                    {/* Troféu */}
                    <div style={{ fontSize: p.size, marginBottom: isLeader ? 12 : 8 }}>
                      {rank.trophyBg ? renderTrophy(rank.trophyBg, p.size) : null}
                    </div>

                    {/* Dados */}
                    <div>
                      <h3 style={{ margin: "0 0 8px 0", fontSize: isLeader ? "1.3rem" : "1.1rem", fontWeight: isLeader ? 700 : 600, color: "#1a1a1a" }}>
                        {place.APELIDO || "N/A"}
                      </h3>
                      <div style={{ fontSize: isLeader ? "2.5rem" : "1.8rem", fontWeight: isLeader ? 800 : 700, color: isLeader ? "#FFD700" : "#1a1a1a", marginBottom: isLeader ? 8 : 4 }}>
                        {place.NUM_PEDIDOS || 0}
                      </div>
                      <div style={{ fontSize: isLeader ? "1rem" : ".85rem", color: "#666", fontWeight: isLeader ? 600 : 500 }}>
                        {place.TOTAL_VALOR?.toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 0 }) || "R$ 0"}
                      </div>
                    </div>
                  </div>
                );
              })}
            </div>

            {/* Lista completa */}
            <div style={{ background: "white", borderRadius: "16px", padding: "32px", boxShadow: "0 4px 20px rgba(0,0,0,.08)", border: "1px solid #f0f0f0" }}>
              <h2 style={{ fontSize: "1.5rem", fontWeight: 600, color: "#1a1a1a", margin: "0 0 24px 0" }}>Ranking Completo</h2>

              <div style={{ display: "flex", flexDirection: "column", gap: "12px" }}>
                {sortedSalesData.map((entry, index) => {
                  const percentage = maxSales > 0 ? (entry.NUM_PEDIDOS / maxSales) * 100 : 0;
                  const animatedValue = animatedValues[entry.APELIDO] || 0;
                  const rank = getRankPosition(index);

                  return (
                    <div
                      key={entry.APELIDO || index}
                      className="ranking-card"
                      style={{
                        background: index < 3 ? "#fafafa" : "white",
                        border: index < 3 ? "1px solid #e0e0e0" : "1px solid #f5f5f5",
                        borderRadius: "12px",
                        padding: "20px",
                        display: "grid",
                        gridTemplateColumns: "60px 1fr 100px 120px",
                        alignItems: "center",
                        gap: "16px",
                        animation: isVisible ? `slideInUp .4s ease ${index * 0.05}s both` : "none",
                      }}
                    >
                      {/* Posição */}
                      <div style={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                        <div
                          style={{
                            width: 40,
                            height: 40,
                            borderRadius: "50%",
                            background: index < 3 ? rank.gradient : "#f8f9fa",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: 18,
                            fontWeight: 600,
                            color: index < 3 ? "white" : "#666",
                          }}
                        >
                          {index < 3 ? <FaTrophy /> : index + 1}
                        </div>
                      </div>

                      {/* Nome + Progresso */}
                      <div>
                        <h4 style={{ margin: "0 0 8px 0", fontSize: "1.1rem", fontWeight: 600, color: "#1a1a1a" }}>
                          {entry.APELIDO}
                        </h4>
                        <div style={{ background: "#f0f0f0", borderRadius: 8, height: 6, overflow: "hidden" }}>
                          <div
                            className="progress-bar-animated"
                            style={{
                              width: `${maxSales > 0 ? (animatedValue / maxSales) * 100 : 0}%`,
                              height: "100%",
                              background: getProgressColor(percentage),
                              borderRadius: 8,
                            }}
                          />
                        </div>
                      </div>

                      {/* Pedidos */}
                      <div style={{ textAlign: "center" }}>
                        <div style={{ fontSize: "1.5rem", fontWeight: 700, color: "#1a1a1a", marginBottom: 2 }}>
                          {animatedValue}
                        </div>
                        <div style={{ fontSize: ".8rem", color: "#666", fontWeight: 500 }}>pedidos</div>
                      </div>

                      {/* Valor */}
                      <div style={{ textAlign: "right" }}>
                        <div style={{ fontSize: "1.1rem", fontWeight: 700, color: "#10b981", marginBottom: 2 }}>
                          {entry.TOTAL_VALOR?.toLocaleString("pt-BR", { style: "currency", currency: "BRL", minimumFractionDigits: 0 }) || "R$ 0"}
                        </div>
                        <div style={{ fontSize: ".8rem", color: "#666", fontWeight: 500 }}>faturamento</div>
                      </div>
                    </div>
                  );
                })}

                {/* Estado vazio (opcional) */}
                {sortedSalesData.length === 0 && (
                  <div style={{ padding: 24, textAlign: "center", color: "#666" }}>Sem dados para exibir.</div>
                )}
              </div>
            </div>
          </div>
        </div>
      </>
    );
  };

  const OrderList = () => {
    const [orders, setOrders] = useState([]);
    const [isLoading, setIsLoading] = useState(true);
    const [selectedDate, setSelectedDate] = useState(new Date());
    const [marketplaceFilters, setMarketplaceFilters] = useState({});

    // Lista única de marketplaces
    const uniqueMarketplaces = [...new Set(orders.map(order => order.APELIDO))];

    const handleMarketplaceFilter = (marketplace) => {
      setMarketplaceFilters(prev => ({
        ...prev,
        [marketplace]: !prev[marketplace]
      }));
    };

    useEffect(() => {
      setIsLoading(true);
      const formattedDate = selectedDate.toISOString().split('T')[0];
      console.log(formattedDate);

      // Simulação da API - substitua pela sua chamada real
      // setTimeout(() => {
      //   const mockData = [
      //     {
      //       PEDIDO: '12345',
      //       CODIGO: 'PROD001',
      //       DESCRICAO: 'Smartphone Samsung Galaxy A54',
      //       QUANTIDADE: 1,
      //       VALOR_TOTAL_ITEM: 1299.99,
      //       INTEGRADO: 'fulfillment',
      //       VALOR: 1299.99,
      //       VLRFRETE: 29.90,
      //       APELIDO: 'Mercado Livre'
      //     },
      //     {
      //       PEDIDO: '12345',
      //       CODIGO: 'PROD002',
      //       DESCRICAO: 'Capinha Transparente',
      //       QUANTIDADE: 1,
      //       VALOR_TOTAL_ITEM: 19.99,
      //       INTEGRADO: 'normal',
      //       VALOR: 19.99,
      //       VLRFRETE: 0,
      //       APELIDO: 'Mercado Livre'
      //     },
      //     {
      //       PEDIDO: '12346',
      //       CODIGO: 'PROD003',
      //       DESCRICAO: 'Fone Bluetooth JBL',
      //       QUANTIDADE: 2,
      //       VALOR_TOTAL_ITEM: 199.98,
      //       INTEGRADO: 'normal',
      //       VALOR: 99.99,
      //       VLRFRETE: 15.50,
      //       APELIDO: 'Shopee'
      //     }
      //   ];
      //   setOrders(mockData);
      //   setIsLoading(false);
      // }, 1000);


      apinode
        .get(`auth/vendasporitem/${localStorage.idconta}`, {
          params: { data: formattedDate },
        })
        .then((response) => {
          setOrders(response.data);
          setIsLoading(false);
        })
        .catch((error) => {
          console.error('Erro na requisição:', error);
          setIsLoading(false);
        });

    }, [selectedDate]);

    // Agrupando os pedidos pelo valor de order.PEDIDO
    const groupedOrders = orders
      .filter(order => {
        const selectedMarketplaces = Object.keys(marketplaceFilters).filter(key => marketplaceFilters[key]);
        return selectedMarketplaces.length === 0 || selectedMarketplaces.includes(order.APELIDO);
      })
      .reduce((grouped, order) => {
        const pedido = order.PEDIDO;
        if (!grouped[pedido]) {
          grouped[pedido] = {
            ...order,
            FRETE: 0,
            DESCRICAO: [],
            QUANTIDADE: [],
            VALOR_TOTAL_ITEM: [],
            INTEGRADO: [],
          };
        }
        grouped[pedido].FRETE += order.VLRFRETE;
        grouped[pedido].DESCRICAO.push(order.DESCRICAO);
        grouped[pedido].QUANTIDADE.push(order.QUANTIDADE);
        grouped[pedido].VALOR_TOTAL_ITEM.push(order.VALOR_TOTAL_ITEM);
        grouped[pedido].INTEGRADO.push(order.INTEGRADO);
        return grouped;
      }, {});

    const formatCurrency = (value) => {
      return value?.toLocaleString('pt-BR', {
        style: 'currency',
        currency: 'BRL',
      }) || '';
    };

    return (
      <div style={{
        height: '100vh',
        background: '#f8fafc',
        padding: '1.5rem',
        fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}>
        <div style={{
          maxWidth: '1400px',
          margin: '0 auto',
          width: '100%',
          height: '100%',
          display: 'flex',
          flexDirection: 'column'
        }}>
          {/* Header */}
          <div style={{
            background: 'white',
            borderRadius: '12px',
            padding: '1.5rem',
            marginBottom: '1.5rem',
            border: '1px solid #e2e8f0',
            boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
            flexShrink: 0
          }}>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              flexWrap: 'wrap',
              gap: '1rem'
            }}>
              <div style={{
                display: 'flex',
                alignItems: 'center',
                gap: '0.75rem'
              }}>
                <div style={{
                  background: 'linear-gradient(135deg, #3b82f6, #1d4ed8)',
                  borderRadius: '8px',
                  padding: '8px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}>
                  <ShoppingBag size={20} color="white" />
                </div>
                <h1 style={{
                  color: '#1e293b',
                  fontSize: '1.5rem',
                  fontWeight: '600',
                  margin: 0
                }}>
                  Pedidos do Dia
                </h1>
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.5rem',
                  color: '#64748b',
                  fontSize: '0.875rem'
                }}>
                  <Calendar size={14} />
                  <span>{selectedDate.toLocaleDateString('pt-BR')}</span>
                </div>
              </div>

              {/* Filtros por Marketplace */}
              {uniqueMarketplaces.length > 0 && (
                <div style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: '0.75rem',
                  flexWrap: 'wrap'
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    color: '#64748b',
                    fontSize: '0.875rem',
                    fontWeight: '500'
                  }}>
                    <Filter size={14} />
                    <span>Filtrar:</span>
                  </div>
                  {uniqueMarketplaces.map(marketplace => (
                    <label
                      key={marketplace}
                      style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '0.5rem',
                        cursor: 'pointer',
                        padding: '0.25rem 0.5rem',
                        borderRadius: '6px',
                        background: marketplaceFilters[marketplace] ? '#f1f5f9' : 'transparent',
                        border: '1px solid',
                        borderColor: marketplaceFilters[marketplace] ? '#3b82f6' : '#e2e8f0',
                        fontSize: '0.875rem',
                        fontWeight: '500',
                        color: marketplaceFilters[marketplace] ? '#3b82f6' : '#64748b',
                        transition: 'all 0.2s ease'
                      }}
                    >
                      <input
                        type="checkbox"
                        checked={marketplaceFilters[marketplace] || false}
                        onChange={() => handleMarketplaceFilter(marketplace)}
                        style={{ margin: 0 }}
                      />
                      {marketplace}
                    </label>
                  ))}
                </div>
              )}
            </div>
          </div>

          {/* Content */}
          <div style={{
            flex: 1,
            overflow: 'hidden',
            display: 'flex',
            flexDirection: 'column'
          }}>
            {isLoading ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                background: 'white',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)'
              }}>
                <Loader2
                  size={32}
                  color="#3b82f6"
                  style={{
                    animation: 'spin 1s linear infinite'
                  }}
                />
                <p style={{
                  color: '#64748b',
                  marginTop: '1rem',
                  fontSize: '0.875rem'
                }}>
                  Carregando pedidos...
                </p>
              </div>
            ) : Object.keys(groupedOrders).length === 0 ? (
              <div style={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                height: '100%',
                background: 'white',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                textAlign: 'center',
                padding: '3rem'
              }}>
                <ShoppingBag size={32} color="#cbd5e1" style={{ marginBottom: '1rem' }} />
                <p style={{
                  color: '#64748b',
                  fontSize: '0.875rem',
                  margin: 0
                }}>
                  Nenhum pedido encontrado para esta data
                </p>
              </div>
            ) : (
              <div style={{
                background: 'white',
                borderRadius: '12px',
                border: '1px solid #e2e8f0',
                boxShadow: '0 1px 3px 0 rgba(0, 0, 0, 0.1)',
                height: '100%',
                display: 'flex',
                flexDirection: 'column'
              }}>
                {/* Header da lista com contadores */}
                <div style={{
                  padding: '1rem 1.5rem',
                  borderBottom: '1px solid #f1f5f9',
                  flexShrink: 0
                }}>
                  <div style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'space-between'
                  }}>
                    <h2 style={{
                      margin: 0,
                      fontSize: '1.125rem',
                      fontWeight: '600',
                      color: '#1e293b'
                    }}>
                      Lista de Pedidos
                    </h2>
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: '0.5rem',
                      fontSize: '0.875rem',
                      color: '#64748b'
                    }}>
                      <Package size={14} />
                      <span>{Object.keys(groupedOrders).length} pedidos encontrados</span>
                    </div>
                  </div>
                </div>

                {/* Lista scrollável */}
                <div style={{
                  flex: 1,
                  overflowY: 'auto',
                  padding: '1rem',
                  display: 'grid',
                  gap: '0.75rem',
                  alignContent: 'flex-start'
                }}>
                  {Object.keys(groupedOrders).map((pedido) => (
                    <div
                      key={pedido}
                      style={{
                        background: '#f8fafc',
                        borderRadius: '8px',
                        padding: '1rem',
                        border: '1px solid #e2e8f0',
                        transition: 'all 0.2s ease'
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.background = '#f1f5f9';
                        e.currentTarget.style.borderColor = '#cbd5e1';
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.background = '#f8fafc';
                        e.currentTarget.style.borderColor = '#e2e8f0';
                      }}
                    >
                      {/* Header do Pedido */}
                      <div style={{
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        marginBottom: '0.75rem',
                        paddingBottom: '0.5rem',
                        borderBottom: '1px solid #e2e8f0'
                      }}>
                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}>
                          <div style={{
                            background: '#3b82f6',
                            borderRadius: '4px',
                            padding: '4px',
                            display: 'flex',
                            alignItems: 'center'
                          }}>
                            <Hash size={12} color="white" />
                          </div>
                          <h3 style={{
                            margin: 0,
                            fontSize: '0.875rem',
                            fontWeight: '600',
                            color: '#1e293b'
                          }}>
                            Pedido #{pedido}
                          </h3>
                        </div>

                        <div style={{
                          display: 'flex',
                          alignItems: 'center',
                          gap: '0.5rem'
                        }}>
                          <div style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: '0.25rem',
                            background: 'white',
                            padding: '0.25rem 0.5rem',
                            borderRadius: '4px',
                            fontSize: '0.75rem',
                            fontWeight: '500',
                            color: '#64748b',
                            border: '1px solid #e2e8f0'
                          }}>
                            <MapPin size={10} />
                            {groupedOrders[pedido].APELIDO}
                          </div>

                          {/* Frete inline */}
                          {groupedOrders[pedido].FRETE !== 0 && (
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              background: '#fef3c7',
                              padding: '0.25rem 0.5rem',
                              borderRadius: '4px',
                              fontSize: '0.75rem',
                              fontWeight: '500',
                              color: '#92400e',
                              border: '1px solid #fed7aa'
                            }}>
                              <Truck size={10} />
                              {formatCurrency(groupedOrders[pedido].FRETE)}
                            </div>
                          )}
                        </div>
                      </div>

                      {/* Itens do Pedido */}
                      <div style={{
                        display: 'grid',
                        gap: '0.5rem'
                      }}>
                        {groupedOrders[pedido].DESCRICAO.map((descricao, index) => (
                          <div
                            key={index}
                            style={{
                              display: 'flex',
                              alignItems: 'center',
                              justifyContent: 'space-between',
                              padding: '0.5rem',
                              background: 'white',
                              borderRadius: '4px',
                              border: '1px solid #f1f5f9'
                            }}
                          >
                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.5rem',
                              flex: 1,
                              minWidth: 0
                            }}>
                              <Package size={12} color="#64748b" />
                              <span style={{
                                fontSize: '0.8125rem',
                                fontWeight: '500',
                                color: '#1e293b',
                                flex: 1,
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                              }}>
                                {descricao}
                              </span>

                              <div style={{
                                display: 'flex',
                                alignItems: 'center',
                                gap: '0.375rem',
                                flexShrink: 0
                              }}>
                                <span style={{
                                  background: '#e2e8f0',
                                  padding: '0.125rem 0.25rem',
                                  borderRadius: '3px',
                                  fontSize: '0.6875rem',
                                  fontWeight: '500',
                                  color: '#475569'
                                }}>
                                  {groupedOrders[pedido].QUANTIDADE[index]}
                                </span>

                                {groupedOrders[pedido].INTEGRADO[index] === 'fulfillment' && (
                                  <div style={{
                                    display: 'flex',
                                    alignItems: 'center',
                                    gap: '0.125rem',
                                    background: '#dcfce7',
                                    color: '#166534',
                                    padding: '0.125rem 0.25rem',
                                    borderRadius: '3px',
                                    fontSize: '0.6875rem',
                                    fontWeight: '500',
                                    border: '1px solid #bbf7d0'
                                  }}>
                                    <Zap size={8} />
                                    Full
                                  </div>
                                )}
                              </div>
                            </div>

                            <div style={{
                              display: 'flex',
                              alignItems: 'center',
                              gap: '0.25rem',
                              background: '#059669',
                              color: 'white',
                              padding: '0.25rem 0.375rem',
                              borderRadius: '4px',
                              fontWeight: '600',
                              fontSize: '0.75rem',
                              marginLeft: '0.5rem',
                              flexShrink: 0
                            }}>
                              <DollarSign size={10} />
                              {formatCurrency(groupedOrders[pedido].VALOR_TOTAL_ITEM[index])}
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  };

  return (
    <>
      {localStorage.admin === 'NAO' ? (
        <>
          <Navbar />

          <div className="mt-page">
            <Row>
              <Col>
                <Card
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #ddd',
                  }}
                >

                  <Card.Body style={{ padding: '20px' }}>
                    <Card.Text
                      style={{
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        color: '#333',
                      }}
                    >
                      {greeting}, {localStorage.username}!
                    </Card.Text>
                  </Card.Body>
                </Card>
                {/* <GreetingCard /> */}
              </Col>
            </Row>
            <CatalogNotification />




            <Col lg={12}>
              <OrderList />
            </Col>
            <DashboardMonthly />
           
            <AnunciosDashboard data={anuncios} />


            <ItemList />

            {/* {dadosMetricas ? (
              <ScheduleCard sellerData={dadosMetricas.results} />
            ) : (
              <p>Conta sem informações disponíveis</p>
            )} */}
            <div className="p-6">
              <ScheduleCard sellerData={dadosMetricas.results} />
            </div>

            <CodigosAutorizacao />
          </div>
        </>
      ) : (
        <>
          <Navbar />

          <div className="mt-page">
           
            <Row>
              <Col>
                <Card
                  style={{
                    backgroundColor: '#f8f9fa',
                    border: '1px solid #ddd',
                  }}
                >
                  <Card.Body style={{ padding: '20px' }}>
                    <Card.Text
                      style={{
                        fontSize: '1.5rem',
                        fontWeight: 'bold',
                        color: '#333',
                      }}
                    >
                      {greeting}, {localStorage.username}!
                    </Card.Text>
                  </Card.Body>
                </Card>
              </Col>
            </Row>
            <CatalogNotification />

            <DashboardVendas
              dadosDashboard={dadosDashboard}
              isLoading={isLoading}
              selectedDate={selectedDate}
              onDateChange={handleDateChange}
            />
            {/* <Card>
              <Card.Body>
                <div className="dashboard-header"></div>
                <div className="date-selector-container">
                  <DatePicker
                    selected={selectedDate}
                    onChange={handleDateChange}
                    dateFormat="dd/MM/yyyy"
                    locale={ptBR} // Defina a localização como pt-BR
                    className="form-control"
                  />
                </div>

                {isLoading ? ( // Exibe a mensagem de carregamento se isLoading for verdadeiro
                  <p>Carregando...</p>
                ) : (
                  <div>
                    <Row className="gx-3 gx-md-4 gx-lg-5">
                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card
                          className="dashboard-card card-primary"
                          style={{
                            cursor: 'pointer',
                          }}
                          onClick={() => {
                            setIsModalDailySalesOpen(true)
                            getDailySales()
                          }}
                        >
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faDollarSign}
                              className="dashboard-icon dollar-icon"
                            />

                            <Card.Title className="dashboard-card-title">
                              Total de Vendas do Dia
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard &&
                              dadosDashboard.totalVendasDia &&
                              dadosDashboard.totalVendasDia.TOTALVENDASDIA
                                ? dadosDashboard.totalVendasDia.TOTALVENDASDIA.toLocaleString(
                                    'pt-BR',
                                    {
                                      style: 'currency',
                                      currency: 'BRL',
                                    },
                                  )
                                : '0'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card className="dashboard-card card-secondary">
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faShoppingCart}
                              className="dashboard-icon cart-icon"
                            />
                            <Card.Title className="dashboard-card-title">
                              Quantidade de Pedidos
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard &&
                              dadosDashboard.quantidadePedidos
                                ? dadosDashboard.quantidadePedidos
                                    .QUANTIDADEPEDIDOS || 0
                                : 'Carregando...'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card className="dashboard-card card-tertiary">
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faBox}
                              className="dashboard-icon box-icon"
                            />
                            <Card.Title className="dashboard-card-title">
                              Total de Vendas Fulfillment
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard &&
                              dadosDashboard.totalVendasFulfillment &&
                              dadosDashboard.totalVendasFulfillment
                                .TOTALVENDASFULFILLMENT
                                ? dadosDashboard.totalVendasFulfillment.TOTALVENDASFULFILLMENT.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                      style: 'currency',
                                      currency: 'BRL',
                                    },
                                  )
                                : '0,00'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                    <Row className="gx-3 gx-md-4 gx-lg-5">
                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card className="dashboard-card card-quaternary">
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faMoneyBillWave}
                              className="dashboard-icon money-icon"
                            />
                            <Card.Title className="dashboard-card-title">
                              Quantidade vendas full(ML)
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard && dadosDashboard.totalVendasFull
                                ? dadosDashboard.totalVendasFull.TOTALVENDASFULL
                                : 'Carregando...'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card className="dashboard-card card-quinary">
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faTimesCircle}
                              className="dashboard-icon cancel-icon"
                            />
                            <Card.Title className="dashboard-card-title">
                              Total de Pedidos Cancelados
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard &&
                              dadosDashboard.totalPedidosCancelados
                                ? dadosDashboard.totalPedidosCancelados
                                    .TOTALPEDIDOSCANCELADOS
                                : 'Carregando...'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card className="dashboard-card card-quinary">
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faTruckFast}
                              className="dashboard-icon cancel-icon"
                            />
                            <Card.Title className="dashboard-card-title">
                              Frete
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard &&
                              dadosDashboard.totalFrete.TOTALFRETE
                                ? dadosDashboard.totalFrete.TOTALFRETE.toLocaleString(
                                    'pt-BR',
                                    {
                                      minimumFractionDigits: 2,
                                      style: 'currency',
                                      currency: 'BRL',
                                    },
                                  )
                                : '0,00'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card className="dashboard-card card-sextary">
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faMoneyBillTrendUp}
                              className="dashboard-icon cancel-icon"
                            />
                            <Card.Title className="dashboard-card-title">
                              Total Bruto
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard &&
                              dadosDashboard.totalVendasFulfillment
                                ? (
                                    (dadosDashboard.totalVendasDia
                                      .TOTALVENDASDIA || 0) +
                                    dadosDashboard.totalVendasFulfillment
                                      .TOTALVENDASFULFILLMENT
                                  ).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                  })
                                : '0,00'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card className="dashboard-card card-sextary">
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faMoneyBills}
                              className="dashboard-icon cancel-icon"
                            />
                            <Card.Title className="dashboard-card-title">
                              Total Liq. (Total - Frete)
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard &&
                              dadosDashboard.totalVendasDia &&
                              dadosDashboard.totalVendasFulfillment &&
                              dadosDashboard.totalFrete
                                ? (
                                    (dadosDashboard.totalVendasDia
                                      .TOTALVENDASDIA || 0) +
                                    (dadosDashboard.totalVendasFulfillment
                                      .TOTALVENDASFULFILLMENT || 0) -
                                    (dadosDashboard.totalFrete.TOTALFRETE || 0)
                                  ).toLocaleString('pt-BR', {
                                    style: 'currency',
                                    currency: 'BRL',
                                  })
                                : '0,00'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>

                      <Col
                        xs={12}
                        sm={6}
                        md={4}
                      >
                        <Card
                          className="dashboard-card card-sextary"
                          onClick={handleShow}
                          style={{ cursor: 'pointer' }}
                        >
                          <Card.Body>
                            <FontAwesomeIcon
                              icon={faGear}
                              className="dashboard-icon cancel-icon"
                            />
                            <Card.Title className="dashboard-card-title">
                              Total em vendas de Parts
                            </Card.Title>
                            <Card.Text className="dashboard-value">
                              {dadosDashboard &&
                              dadosDashboard.totalParts &&
                              dadosDashboard.totalParts.TOTALGEAR
                                ? dadosDashboard.totalParts.TOTALGEAR.toLocaleString(
                                    'pt-BR',
                                    {
                                      style: 'currency',
                                      currency: 'BRL',
                                    },
                                  )
                                : '0,00'}
                            </Card.Text>
                          </Card.Body>
                        </Card>
                      </Col>
                    </Row>
                  </div>
                )}
              </Card.Body>
            </Card> */}

            <DashboardMonthly />

            <AnunciosDashboard data={anuncios} />

            <AccountStatistics />

            {dadosVendas.length > 0 && <SalesRanking />}

            <TabelaVendas totalDiario={totalDiario} />

            {dadosVendasFull.length > 0 && (
              <FulfillmentDashboard dadosVendas={dadosVendasFull} />
            )}

            <ItemList />

            <Row>
              <Col md={6}>
                <Card className="mb-3">
                  <Card.Body>
                    <ComparativoVendasCard
                      informacoesVendas={dadosVendasComparativo}
                    />
                  </Card.Body>
                </Card>
              </Col>

              <Col md={6}>
                <Card className="mb-3">
                  <Card.Body>
                    <ComparativoValorTotalCard
                      informacoesVendas={dadosVendasComparativo}
                    />
                  </Card.Body>
                </Card>
              </Col>
            </Row>

            <Col lg={12}>
              <OrderList />
            </Col>

            {/* <Col md={12}>
              {dadosMetricas ? (
                <ScheduleCard sellerData={dadosMetricas.results} />
              ) : (
                <p>Conta sem informações disponíveis</p>
              )}
            </Col> */}

            <div className="p-12">
              <ScheduleCard sellerData={dadosMetricas.results} />
            </div>


            <CodigosAutorizacao />

            <Row>
              <div className="mb-3">
                <Dropdown>
                  <Dropdown.Toggle
                    variant="secondary"
                    id="dropdownAno"
                  >
                    Ano Selecionado: {anoSelecionado}
                  </Dropdown.Toggle>
                  <Dropdown.Menu>
                    {anosDisponiveis.map((ano) => (
                      <Dropdown.Item
                        key={ano}
                        onClick={() => handleDropdownChange(ano)}
                      >
                        {ano}
                      </Dropdown.Item>
                    ))}
                  </Dropdown.Menu>
                </Dropdown>
              </div>

              {isLoadingAno ? ( // Exibe a mensagem de carregamento se isLoading for verdadeiro
                <p>Carregando...</p>
              ) : dados.length > 0 ? ( // Verifica se há dados disponíveis
                <Col md={12}>
                  <Card className="mb-3">
                    <Card.Body>
                      <div className="row">
                        <div className="col-md-6">
                          <GraficoComparativo />
                        </div>
                        <div className="col-md-6">
                          <Card className="mb-3">
                            <Card.Body>
                              <div className="table-responsive">
                                <table className="table table-bordered table-striped">
                                  <TabelaComparativa />
                                </table>
                              </div>
                            </Card.Body>
                          </Card>
                        </div>
                      </div>
                    </Card.Body>
                  </Card>
                </Col>
              ) : (
                <Col md={12}>
                  <Card className="mb-3">
                    <Card.Body>
                      <p>Nenhum dado disponível para exibir.</p>
                    </Card.Body>
                  </Card>
                </Col>
              )}
            </Row>


            {/* <Card className="mb-3">
              <Card.Body>
                <h1>Anúncios sem SKU</h1>

                <div
                  style={{
                    minHeight: '50vh',
                    flex: 1,
                    display: 'flex',
                    alignItems: 'flex-start',
                    justifyContent: 'flex-start',
                    gap: 20,
                    overflowX: 'auto',
                  }}
                >
                  {anuncios.map((anuncio) => {
                    return (
                      <div
                        style={{
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                        }}
                      >
                        <h5>{anuncio.apelido}</h5>

                        <Pie
                          key={anuncio.apelido}
                          data={{
                            labels: ['Total de Anúncios', 'Sem SKU'],
                            datasets: [
                              {
                                label: 'Quantidade',
                                data: [anuncio.total, anuncio.sem],
                                backgroundColor: [' #206e03 ', ' #eb1717 '],
                              },
                            ],
                          }}
                          options={{
                            responsive: true,
                            plugins: {
                              legend: {
                                position: 'top',
                              },
                              tooltip: {
                                enabled: true,
                              },
                            },
                          }}
                        />
                      </div>
                    )
                  })}
                </div>
              </Card.Body>
            </Card> */}
          </div>
        </>
      )}

      {isModalDailySalesOpen && (
        <Modal
          show={isModalDailySalesOpen}
          centered
          size="lg"
          dialogClassName="custom-modalzpl"
        >
          <Modal.Header>
            <Modal.Title>Vendas de Hoje</Modal.Title>
          </Modal.Header>

          <Modal.Body>
            {isDailySalesLoading ? (
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  alignItems: 'center',
                  justifyContent: 'center',
                  gap: 10,
                }}
              >
                <CustomSpinner />

                <p>Carregando...</p>
              </div>
            ) : (
              <Table>
                <thead>
                  <tr>
                    <th>Pedido</th>
                    <th>Cliente</th>
                    <th>Valor</th>
                    <th>Ação</th>
                  </tr>
                </thead>
                <tbody>
                  {dailySales.map((sale) => (
                    <tr>
                      <td>{sale.pedido}</td>
                      <td>{sale.cliente}</td>
                      <td>{formatPrice(sale.valor)}</td>
                      <td>
                        <OverlayTrigger
                          overlay={
                            <BootstrapTooltip>
                              Visualizar Pedido
                            </BootstrapTooltip>
                          }
                        >
                          <CustomButton
                            onClick={() => {
                              navigate(`/pedido/editar/${sale.pedido}`)
                            }}
                          >
                            <BoxArrowUpRight size={15} />
                          </CustomButton>
                        </OverlayTrigger>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </Table>
            )}
          </Modal.Body>

          <Modal.Footer>
            <CustomButton
              title="Fechar"
              onClick={() => setIsModalDailySalesOpen(false)}
              color="#8f8f8f"
            />
          </Modal.Footer>
        </Modal>
      )}
    </>
  )
}

export default Main
